//import { Component, Input } from '@angular/core';
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import { Observable, Subscription } from 'rxjs';
//import { SpiderChartService } from '../../spider-chart.service';
import { TableViewService } from '../../table-view.service';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';

HighchartsMore(Highcharts);
HighchartsAccessibility(Highcharts);

@Component({
  selector: 'app-spider-chart02',
  template: `
    <div [id]="'chart-container'+id" [ngStyle]="{'height': popUp ? '30em' : (height === '11em' ? '10em' : '21em')}" [style]="'height:'+this.height"></div>
  `,
})
export class Spiderchart02Component {
  seriesData: any[] = [];
  ChartData: any[] = [];
  sampleSizeValues: any;
  chart: any;
  custom: any[] = [];
  ChartProperties: any;
  event: any;
  changeValue: any;
  significanceValue: any;
  significanceValue2: any;
  data: any;
  chartCategories: any;
  userselectedchartdata: any;
  seriescolor: any;
  
  @Input() gridTempleteColumns: any;
  @Input() popUpp: any;
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any;
  configuredProperties: any;
  maxDataPoints: any = 2;
  private subscriptions: Subscription = new Subscription();
  DefaultConfidenceLevel: any = "";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  chartMainData: any = [];
  
  ngOnInit(): void {
    if (this.isOutput) {
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      if(this.customData){
        for(let i=0;i<this._configService.allPageOutputDataWithoutTrend[0].length;i++){
             if(this.customData.widget_name == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name){
               this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties=this.customData.customizationProperties;
             }
        }
      }
      this.customData = this.customData.metric[0];
      this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      this.maxDataPoints = this.popUp ? 6 : this.maxDataPoints;
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updateSig();
        }));
    }
    else{
          this.getData().subscribe(
            (jsonData: any) => {
              this.data = jsonData[0];
              this.ChartData = jsonData[0]['data'];
              this.ChartProperties = jsonData[0]["properties"][0];
              this.route.paramMap.subscribe((params) => {
                const userData = history.state.userData;
                this.userselectedchartdata = userData; // Use the userData object as needed
                if (this.userselectedchartdata?.widgetEditSelection) {
                  if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
                    this.ChartProperties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
                  }
                }
              });
              this.renderChart2('chart-container'+ this.id, this.data['data'], this.ChartProperties);
            }
          );
      }
  }

  constructor(private http: HttpClient, private spiderService: TableViewService,private _customSnapshotService: CustomsnapshotService,private _configService: SnapshotService,private router: Router,
    private route: ActivatedRoute) { }

  getData(): Observable<any> {
    return this.http.get<any>('assets/Data/spiderData.json');
  }

  updateSig() {
    this.subscriptions.add(
      this.http.get<any>('assets/Data/spiderData.json').subscribe((data) => {
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.data = data[0];
        this.ChartProperties = this.data['properties'][0];
        this.ChartProperties = this.configuredProperties != undefined ? this.configuredProperties : this.ChartProperties;
         this.seriescolor = this.spiderService.color;
        // this.seriesgradientcolor = this.piechartservice.linearGradients1;
        // this.samplesizeconstant = this.piechartservice.samplesizeconstant;
        this.ChartProperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
        this.ChartProperties.dataLabelPosition = 'right';
        this.ChartProperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.ChartProperties.datalabelStyle;
        this.Sig_LowerLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_99
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_99
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_99
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_99
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
                this.renderChart2('chart-container'+ this.id, this.data['data'], this.ChartProperties);
      }));
  }

  preparemainChartData(data: any) {
    this.chartMainData = [];
    // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;
        
    if (this._configService.selectedSnapshotType.toLowerCase().includes('multi')) {

      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": dataArr.colChild.split("|").length>1?dataArr.colChild.split("|")[1]:dataArr.colChild,
            "Category Name": lev2.option            ,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value
          }
          this.chartMainData.push(d1);
        })
      })
    }
    else {
      let i = 0;
      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": dataArr.colChild.split("|").length>1?dataArr.colChild.split("|")[1]:dataArr.colChild,
            "Category Name": lev2.option,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value
          }
          this.chartMainData.push(d1);
        });
      });
    }

  }

  seriesObject: any = {};
  accessSeriesValues(islowSample: any,data:any) {
    if(this.isOutput){
      const seriesObjects: any = {};
      const categories: string[] = [];
      let i=0;
  
      for (const series of data) {
        const seriesName = series["Series Name"];
        const roundedValue = series["Rounded Value"];
        const Value = series["Label"];
        let numericValue = (Value === " " || Value === null) ? 0 : parseFloat(Number(Value).toFixed(this.ChartProperties.decimalRoundOff));
        let label = (series.Label);
        const change = series["Change value vs PY"] != null?parseFloat(series["Change value vs PY"]):series["Change value vs PY"];
        const significance = parseFloat(series["Significance"]);
        const category = series["Category Name"];
        const sampleSize = series["Sample size"];
        const significance2 = series["Significance2"];
        const ValueForIndex = series["ValueForIndex"];
        const ActualIndexValue = series["ActualIndexValue"];
        const Sig_LowerLimt = series["Sig_LowerLimt"];
        const Sig_UpperLimt = series["Sig_UpperLimt"];
        const isPercentage = series["isPercentage"];
        const Significance_Value = series["Significance_Value"];
        const legendkeycolor = this.seriescolor[i];
  
        // Check if chartProperties.showNegative is false and series has negative values
        if (!this.ChartProperties.showNegative && numericValue < 0) {
          continue; // Skip this series
        }
  
        let finalvalue = !islowSample ? numericValue : (parseFloat(series['Sample size']) > this.spiderService.sampleSizeConstant ? numericValue : 0);
        let tooltip ="";
  
        if (!seriesObjects[seriesName]) {
          seriesObjects[seriesName] = {
            name: seriesName,
            data: [],
            label: [],
            changeValue: [],
            roundedValue: [],
            significanceValue: [],
            significanceValue2: [],
            sampleSizeValues: [],
            ValueForIndex:[],
            ActualIndexValue:[],
            isPercentage:[],
            Sig_UpperLimt:[],
            Sig_LowerLimt:[],
            legendkeycolor:[],
            visible: true,
            tooltip:[],
            Significance_Value:[],
            pointPlacement: 'on',
          };
        }
  
        seriesObjects[seriesName].data.push(finalvalue);
        seriesObjects[seriesName].roundedValue.push(roundedValue);
        seriesObjects[seriesName].label.push(label);
        seriesObjects[seriesName].changeValue.push(change);
        seriesObjects[seriesName].significanceValue.push(significance);
        seriesObjects[seriesName].significanceValue2.push(significance2);
        seriesObjects[seriesName].sampleSizeValues.push(sampleSize);
        seriesObjects[seriesName].ValueForIndex.push(ValueForIndex);
        seriesObjects[seriesName].ActualIndexValue.push(ActualIndexValue);
        seriesObjects[seriesName].tooltip.push(tooltip);
        seriesObjects[seriesName].isPercentage.push(isPercentage);
        seriesObjects[seriesName].Sig_LowerLimt.push(Sig_LowerLimt);
        seriesObjects[seriesName].Sig_UpperLimt.push(Sig_UpperLimt);
        seriesObjects[seriesName].Significance_Value.push(Significance_Value);
        seriesObjects[seriesName].legendkeycolor.push(legendkeycolor);
        
        if (!categories.includes(category)) {
          categories.push(category);
        }
        i++;
      }
  
      this.seriesData = Object.values(seriesObjects).map((item: any) => {
        return {
          name: item.name,
          data: item.data,
          label: item.label,
          color: item.color,
          changeValue: item.changeValue,
          roundedValue: item.roundedValue,
          visible: item.visible,
          significanceValue: item.significanceValue,
          significanceValue2: item.significanceValue2,
          sampleSizeValues: item.sampleSizeValues,
          ActualIndexValue:item.ActualIndexValue,
          ValueForIndex:item.ValueForIndex,
          showInlegend: item.showInLegend,
          tooltip: item.tooltip,
          isPercentage:item.isPercentage,
          Sig_LowerLimt:item.Sig_LowerLimt,
          Sig_UpperLimt:item.Sig_UpperLimt,
          Significance_Value:item.Significance_Value,
          pointPlacement: 'on',
          legendkeycolor:item.legendkeycolor
        };
      });
  
      this.chartCategories = categories;
    }
    else{
        const seriesObjects: any = {};
        const categories: string[] = [];

        for (const series of data) {
          const seriesName = series["Series Name"];
          const roundedValue = series["Rounded Value"];
          let numericValue = (roundedValue === " " || roundedValue === null) ? 0 : parseFloat(Number(roundedValue).toFixed(this.ChartProperties.decimalRoundOff));
          let label = (series.Label);
          const change = series["ChangeVs"]!=null?parseFloat(series["ChangeVs"]):series["ChangeVs"];
          const significance = parseFloat(series["Significance"]);
          const category = series["Category Name"];
          const sampleSize = series["Sample size"];
          const significance2 = series["Significance2"];

          // Check if chartProperties.showNegative is false and series has negative values
          if (!this.ChartProperties.showNegative && numericValue < 0) {
            continue; // Skip this series
          }

          let finalvalue = !islowSample ? numericValue : (parseFloat(series['Sample size']) > this.spiderService.sampleSizeConstant ? numericValue : 0);
          let tooltip ="";

          if (!seriesObjects[seriesName]) {
            seriesObjects[seriesName] = {
              name: seriesName,
              data: [],
              label: [],
              changeValue: [],
              roundedValue: [],
              significanceValue: [],
              significanceValue2: [],
              sampleSizeValues: [],
              visible: true,
              tooltip:[],
              pointPlacement: 'on',
            };
          }

          seriesObjects[seriesName].data.push(finalvalue);
          seriesObjects[seriesName].roundedValue.push(roundedValue);
          seriesObjects[seriesName].label.push(label);
          seriesObjects[seriesName].changeValue.push(change);
          seriesObjects[seriesName].significanceValue.push(significance);
          seriesObjects[seriesName].significanceValue2.push(significance2);
          seriesObjects[seriesName].sampleSizeValues.push(sampleSize);
          seriesObjects[seriesName].tooltip.push(tooltip);

          if (!categories.includes(category)) {
            categories.push(category);
          }
        }

        this.seriesData = Object.values(seriesObjects).map((item: any) => {
          return {
            name: item.name,
            data: item.data,
            label: item.label,
            color: item.color,
            changeValue: item.changeValue,
            roundedValue: item.roundedValue,
            visible: item.visible,
            significanceValue: item.significanceValue,
            significanceValue2: item.significanceValue2,
            sampleSizeValues: item.sampleSizeValues,
            showInlegend: item.showInLegend,
            tooltip: item.tooltip,
            pointPlacement: 'on',
          };
        });

        this.chartCategories = categories;
    }
  }

  // customization() {
  //   return this.spiderService.customizationStack1();
  // }

  renderChart2(container2: any, seriesdata: any, properties: any) {
    if(this.isOutput){
      localStorage.setItem("properties", JSON.stringify(properties));
      this.preparemainChartData(this.customData);
      this.accessSeriesValues(this.ChartProperties.datalabelStyle == 'lowSample',this.chartMainData);
      const configService = this._configService;
      let maxDataValue = 0;
      const numberOfTicks = 15;
      const sampleSizeConstant = this.spiderService.sampleSizeConstant;
      let chartType=this.ChartProperties.sectorfill?'area':'line';
      let height = this.height;

  
      if (this.ChartProperties.gradient) {
        this.seriesData.forEach((series, index) => {
          series.color = this.spiderService.color[index % this.spiderService.color.length]; // Assign colors from customColors1
        });
      }
      else {
        this.seriesData.forEach((series, index) => {
          series.color = this.spiderService.color[index % this.spiderService.color.length]; // Assign colors from customColors2
        });
      }
  
      const maxArray: number[] = new Array<number>(this.seriesData[0].data.length).fill(0);
  
      // Find the maximum value at each index across all series
      this.seriesData.forEach(series => {
        series.data.forEach((value: any, index: any) => {
          maxArray[index] = Math.max(maxArray[index], value);
        });
      });
  
      // Now maxArray contains the maximum value at each index
      maxDataValue = Math.max(...maxArray);
      maxDataValue = maxDataValue + Math.ceil(maxDataValue * 0.1);
      const tickInterval = Math.ceil(maxDataValue / numberOfTicks);
      if(this.ChartProperties.sectorfill){
          const options: Highcharts.Options = {
            chart: {
              polar: true,
              type: this.ChartProperties.sectorfill?'area':'line',
              backgroundColor: this.ChartProperties.darkTheme ? this.spiderService.darkThemebg : this.spiderService.lightThemebg,
              style: {
                fontFamily: this.spiderService.textfont,
                color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
              }
            },
            title: {
              text: "",
              align: this.ChartProperties.chartTitlePosition,
              style: {
                color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
                marginleft: '4%',
                fontSize: '2em',
                fontFamily: this.spiderService.textfont
              }
            },
            exporting: {
              enabled: false
            },
            credits: {
              enabled: false,
            },
            legend:
            // {
            //   navigation: {
            //     itemMarginLeft: 10,
            //     activeColor: '#7f7f7f',
            //     animation: true,
            //     arrowSize: 10,
            //     inactiveColor: '#ccc',
            //     style: {
            //       fontSize: '0.7em',
            //       color: this.ChartProperties.darkTheme ? 'white' : '#333',
            //     }
            //   },
            //   // y:chartproperties.legendPosition == 'bottom'?0:4,
            //   maxHeight: this.ChartProperties.legendPosition == 'bottom' ? 45 : 300,
            //   layout:
            //   this.ChartProperties.legendPosition != 'bottom'
            //       ? 'vertical'
            //       : 'horizontal',
            //   // x: this.height == "100%" ? 50 : -20,
            //   y: this.ChartProperties.legendPosition == 'bottom' ? 10 : 0,
            //   // width: height=='100%'?100:'100%',
            //   // itemWidth: 400,
            //   align: this.ChartProperties.legendPosition,
            //   verticalAlign:
            //   this.ChartProperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
            //   symbolWidth: 0,  // Set to a valid non-negative value
            //   symbolHeight: 0, // Set to a valid non-negative value
            //   //symbolWidth: -1,
            //   //symbolHeight: -1,
            //   useHTML: true,
            //   itemMarginTop: 0,    // Adjust this value to reduce the top margin
            //   // itemMarginLeft:-50,
            //   itemMarginBottom: -5,
            //   itemStyle: {
            //     fontWeight: "normal",
            //     fontSize: '0.8em',
            //     cursor: 'pointer'
            //   },
            //   labelFormatter: function (): any {
            //     let point = this as any;
            //     let textcolor = properties.darkTheme ? 'white' : 'black';
            //     if (point.color != "#eeebed" && point.color != "#7f7f7f") {
            //       return '<div style="display:flex;align-items:center;font-size:0.8em;" title="' + point.name + '">'
            //         + '<div style="display:flex;width:10px;height:10px;background-color:' + point.color + ';border-radius:50%"></div>'
            //         + '<div style="width:' + (height != "100%" ? '120px' : '19.5rem') + ';height:20px;font-size:0.8em;padding-left:10px;padding-top:5px;color:' + textcolor + ';overflow:hidden;white-space:nowrap;text-overflow:ellipsis;flex:1;" title="' + point.name + '">' + '   ' + point.name + '   ' + '</div>'
            //         + '</div>';
            //     }
            //   },
            // }, 
            this.spiderService.customizeLegendRadar(this.ChartProperties.showLegend, this.ChartProperties.legendPosition, this.ChartProperties),
            xAxis: {
              categories: this.chartCategories,
              tickmarkPlacement: 'on',
              lineWidth: 0,
              labels: {
                enabled: true,
                rotation: this.spiderService.xAxisLabelOrientation(this.ChartProperties.axisLabelOrientation, this.ChartProperties),
                style: {
                  color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
                  fontFamily: this.spiderService.textfont,
                  fontSize: '0.7em',
                   whiteSpace: 'nowrap', // Prevent line breaks in the label
                   textOverflow: 'ellipsis',
                }
              }
            },
            yAxis: {
              visible:  true,
              gridLineWidth: 1,
              gridLineInterpolation: 'polygon',
              lineWidth: 0,
              gridLineColor: this.ChartProperties.gridlinecolor,
              gridLineDashStyle: this.ChartProperties.gridlinestyle,
              min: 0,
              max: maxDataValue, // Adjust this value based on your data
              tickInterval: tickInterval,
              labels: {
                enabled: this.ChartProperties.axes,
                format: this.ChartProperties.datalabelFormat == "number" ? '{value}' : '{value}%',
                style: {
                  color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
                  fontFamily: this.spiderService.textfont
                },
              },
              gridLineStyle: {
                dashStyle: 'dot',  // 'solid', 'dot', 'dash', etc.
                lineWidth: 1,  // The width of grid lines
                lineColor: this.ChartProperties.gridlinecolor,  // Color for grid lines
              }
            },
            pane: {
              size: '80%'
            },
            tooltip: {
              enabled: true,
              borderWidth: 0,
              useHTML: true,
              shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
              shadow: false,
              backgroundColor: 'rgba(0,0,0,0)',
            
              formatter:function (this: any){
                if (this.series.name === 'Marker1') return false;
                let isDefaultTooltip = "style1";//properties.toolTipStyle;
                let text = properties.showDataLabel == true ? this.series.userOptions.roundedValue[this.point.x] : this.y;
                let text1:any;
                if(text!=null){
                    text1= parseFloat(Number(text).toFixed(properties.decimalRoundOff));
                }
                else{
                  text1=text;
                }
                const dotColor = this.series.color; // Get the series color
                const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
                const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
                if (isDefaultTooltip == "style1") {
                  const commonContent =
                  `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px;font-size: 0.7em; margin: 0; background-color: ${backgroundcolor2}; width:110%">` +
                  `<span style="display: none; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 1rem;">Tooltip Title</span>` +
                  ` ${this.series.name}<br>` +
                  `${this.point.category} : ` +
                  ` ${text1}`;
                return commonContent + '</div>';
                }
                else {
                  const content =
                    `<div style="background-color:${backgroundcolor}; padding: 10%; align-items: center; border: 1px solid ${dotColor}; width:120%">` +
                    `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5%;"></div>` +
                    ` ${this.series.name}` +
                    `<div style="display: block; margin-top: 1%;"><strong>Value:</strong> ${text}</div>`;
                  return content + '</div>';
                }
              }
          },
            plotOptions: {
              series:{
                
                animation: false,
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                enabled: false
              },
              select: {
                enabled: false
              }
            },
              },
              area: {
                dashStyle: this.ChartProperties.Linestyle,
                shadow: this.ChartProperties.shadow ? {
                  color: this.ChartProperties.darkTheme? 'rgba(255,255,255,0.5)':'rgba(0, 0, 0, 0.5)',
                  offsetX: 1,
                  offsetY: 1,
                  opacity: 0.5,
                  width: 5,
                } : false,
                marker: {
                  symbol: properties.markerStyle,
                },
                dataLabels:
                {
                  allowOverlap: this.ChartProperties.dataLabelOverlap,
                  enabled: this.ChartProperties.showDataLabel,
                  align: this.ChartProperties.dataLabelPosition,
                  rotation: this.ChartProperties.datalabelOrientation,
                  color: this.ChartProperties.dataLabelColor == "default" ? (this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor) : this.ChartProperties.dataLabelColor,
                  style: {
                    backgroundColor: 'transparent',
                    shadow: false,
                    borderWidth: 0,
                    textOutline: 'none',
                    borderRadius: 0,
                    padding: '2%',
                    fontFamily: this.spiderService.textfont,
                    fontSize: this.ChartProperties.dataLabelSize,
                    fontWeight: "normal"
                  },
                  formatter: function (this: any) {
                    let sigcolor;
                    const upwardTriangle = '&#9650';
                    const downwardTriangle = '\u25BC';
                    const upColor = 'green';
                    const downColor = 'red';
                    let text; let finalText;
                    let changeText;
                    let sig;
                    let sColor;
      
                    properties.dataLabelFormat = this.isPercentage;
                    let textcolor = properties.dataLabelColor;
                    if (this.series.userOptions.roundedValue[this.point.x] == null || this.series.userOptions.roundedValue[this.point.x] === "") {
                      finalText = "NA";
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
                    if (properties.datalabelStyle == "sigchan") {
                      text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                      changeText = this.series.userOptions.changeValue[this.point.x];
                      sig = this.series.userOptions.significanceValue[this.point.x];
                      sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                      let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                      let changeColor = properties.darkTheme ? 'white' : 'black';
      
                      if (parseFloat(changeText) > 0) {
                        changeText = "+" + changeText;
                      }
                      
                      finalText = (
                        '<span>' + text +
                        (changeText ? '&nbsp<span style="color:' + ';">' +
                          '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                          '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                        '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
      
      
                    if (properties.datalabelStyle == "datalabel") {
                      text = this.y != null? this.y + (properties.datalabelFormat ? '%' : ''):'NA';
                      finalText = (
                        '<span >' + text + '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }

                    if (properties.datalabelStyle === 'sigChange') {
                      let textCheck = configService.CheckLSorIScondition(configService.userRole, String(this.y), Number(this.series.userOptions.sampleSizeValues[this.point.x]));
                      let changeVal = this.series.userOptions.isPercentage[this.point.x] ? (Number(this.series.userOptions.changeValue[this.point.x]) * 100) : (Number(this.series.userOptions.changeValue[this.point.x]));
                      if (this.series.userOptions.changeValue[this.point.x] == null || this.series.userOptions.changeValue[this.point.x] == 'NA') {
                        let text = textCheck + (properties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`;
                        this.series.userOptions.tooltip[this.point.x] = text;
                        return (
                          '<span style="color:' + textcolor + ';">' + text + '</span>'
                        );
                      }
                      else {
                        let sigClass = this.series.userOptions.Significance_Value[this.point.x] < this.series.userOptions.Sig_LowerLimt[this.point.x] ? 'red' : (this.series.userOptions.Significance_Value[this.point.x] > this.series.userOptions.Sig_UpperLimt[this.point.x] ? 'green' : 'black');
                        //let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + (textCheck !='I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) : 'NA'})</span>` : 'NA') : '');
                        let text = textCheck + ((properties.dataLabelFormat && textCheck != 'I/S') ? '%' : '') + ' ' + (textCheck != 'I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${(this.series.userOptions.changeValue[this.point.x] != null ? parseFloat(Number(changeVal).toFixed(1)) + (properties.dataLabelFormat ? '%' : '') : 'NA')})</span>`) : '');
                        this.series.userOptions.tooltip[this.point.x] = text;
                        return (
                          '<span style="color:' + textcolor + ';">' + text + '</span>'
                        );

                      }

                    }

                    if (properties.datalabelStyle === "index") {
                      text = this.y != null? this.y + (properties.datalabelFormat ? '%' : ''):'NA';
                      let text2 = this.series.userOptions.ActualIndexValue[this.point.x] == null ? 'NA' : this.y == -1 ? -1 : this.y != null ? this.series.userOptions.ValueForIndex[this.point.x].toFixed(1) : 'NA';

                      if (text2 == "-1" || text2 == -1) {
                        text2 = "NA";
                      }
                      let color = configService.CheckIndexColoring(String(text2));
                        this.tooltip = text + "(" + text2 + ")";
                        finalText = (
                          '<span style="font-size:0.5rem;color:' + textcolor + ';">' + text + " " + '(' +
                          '<span style="color:' + color + ';font-size:0.45rem;">' + text2 + '</span>' + ')</span>'
                        );
                        this.series.userOptions.tooltip[this.point.x]=finalText;
                        return finalText;
                    }
      
                    if (properties.datalabelStyle == "change") {
                      text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                      changeText = this.series.userOptions.changeValue[this.point.x];
                      let changeColor = properties.darkTheme ? 'white' : 'black';
      
                      if (parseFloat(changeText) > 0) {
                        changeText = "+" + changeText;
                      }
                      
                      finalText = (
                        '<span>' + text +
                        (changeText ? '&nbsp<span style="color:' + ';">' +
                          '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                          '</span>' : '') +
                        '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
      
                    if (properties.datalabelStyle == "significance") {
                      text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA';
                      sig = this.series.userOptions.significanceValue[this.point.x];
                      let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                      sigcolor = sig > 0 ? upColor : (sig < 0 ? downColor : '');
      
                      finalText = (
                        '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
      
                    if (properties.datalabelStyle == "significance2") {
                      text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA';
                      changeText = this.series.userOptions.changeValue[this.point.x];
                      sig = this.series.userOptions.significanceValue[this.point.x];
                      let sig1 = this.series.userOptions.significanceValue2[this.point.x];
                      sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                      let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                      let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? 'white' : 'black');
      
                      if (parseFloat(changeText) > 0) {
                        changeText = "+" + changeText;
                      }
      
                      finalText = (
                        '<span>' + text +
                        (this.y != 0 && changeText ? '&nbsp<span style="color:' + ';"> ' +
                          '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                          '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                        '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
      
                    if (properties.datalabelStyle == 'lowSample') {
                      text = parseFloat(this.series.userOptions.sampleSizeValues[this.point.x]) > sampleSizeConstant ? this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA' : 'LS';
                      finalText = (
                        '<span>' +
                        text +
                        '</span> ' +
                        '<span style="opacity: 0.5"></span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
      
                    finalText = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
                }
              }
            },
            series: this.seriesData,
          } as any;
          this.chart = Highcharts.chart(container2, options);
      }
      else{
        const options: Highcharts.Options = {
          chart: {
            polar: true,
            type: this.ChartProperties.sectorfill?'area':'line',
            backgroundColor: this.ChartProperties.darkTheme ? this.spiderService.darkThemebg : this.spiderService.lightThemebg,
            style: {
              fontFamily: this.spiderService.textfont,
              color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
            }
          },
          title: {
            text: "",
            align: this.ChartProperties.chartTitlePosition,
            style: {
              color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
              marginleft: '4%',
              fontSize: '2em',
              fontFamily: this.spiderService.textfont
            }
          },
          exporting: {
            enabled: false
          },
          credits: {
            enabled: false,
          },
          legend: 
          // {
          //   navigation: {
          //     itemMarginLeft: 10,
          //     activeColor: '#7f7f7f',
          //     animation: true,
          //     arrowSize: 10,
          //     inactiveColor: '#ccc',
          //     style: {
          //       fontSize: '0.7em',
          //       color: this.ChartProperties.darkTheme ? 'white' : '#333',
          //     }
          //   },
          //   // y:chartproperties.legendPosition == 'bottom'?0:4,
          //   maxHeight: this.ChartProperties.legendPosition == 'bottom' ? 45 : 300,
          //   layout:
          //   this.ChartProperties.legendPosition != 'bottom'
          //       ? 'vertical'
          //       : 'horizontal',
          //   // x: this.height == "100%" ? 50 : -20,
          //   y: this.ChartProperties.legendPosition == 'bottom' ? 10 : 0,
          //   // width: height=='100%'?100:'100%',
          //   // itemWidth: 400,
          //   align: this.ChartProperties.legendPosition,
          //   verticalAlign:
          //   this.ChartProperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
          //   symbolWidth: 0,  // Set to a valid non-negative value
          //   symbolHeight: 0, // Set to a valid non-negative value
          //   //symbolWidth: -1,
          //   //symbolHeight: -1,
          //   useHTML: true,
          //   itemMarginTop: 0,    // Adjust this value to reduce the top margin
          //   // itemMarginLeft:-50,
          //   itemMarginBottom: -5,
          //   itemStyle: {
          //     fontWeight: "normal",
          //     fontSize: '0.8em',
          //     cursor: 'pointer'
          //   },
          //   labelFormatter: function (): any {
          //     let point = this as any;
          //     let textcolor = properties.darkTheme ? 'white' : 'black';
          //     if (point.color != "#eeebed" && point.color != "#7f7f7f") {
          //       return '<div style="display:flex;align-items:center;font-size:0.8em;" title="' + point.name + '">'
          //         + '<div style="display:flex;width:10px;height:10px;background-color:' + point.color + ';border-radius:50%"></div>'
          //         + '<div style="width:' + (height != "100%" ? '120px' : '19.5rem') + ';height:20px;font-size:0.8em;padding-left:10px;padding-top:5px;color:' + textcolor + ';overflow:hidden;white-space:nowrap;text-overflow:ellipsis;flex:1;" title="' + point.name + '">' + '   ' + point.name + '   ' + '</div>'
          //         + '</div>';
          //     }
          //   },
          // },
          this.spiderService.customizeLegendRadar(this.ChartProperties.showLegend, this.ChartProperties.legendPosition, this.ChartProperties),
          xAxis: {
            categories: this.chartCategories,
            tickmarkPlacement: 'on',
            lineWidth: 0,
            labels: {
              enabled: true,
              rotation: this.spiderService.xAxisLabelOrientation(this.ChartProperties.axisLabelOrientation, this.ChartProperties),
              style: {
                color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
                fontFamily: this.spiderService.textfont,
                fontSize: '0.7em',
                 whiteSpace: 'nowrap', // Prevent line breaks in the label
                 textOverflow: 'ellipsis'
              }
            }
          },
          yAxis: {
            visible:  true,
            gridLineWidth: 1,
            gridLineInterpolation: 'polygon',
            lineWidth: 0,
            gridLineColor: this.ChartProperties.gridlinecolor,
            gridLineDashStyle: this.ChartProperties.gridlinestyle,
            min: 0,
            max: maxDataValue, // Adjust this value based on your data
            tickInterval: tickInterval,
            opposite: true,
            zIndex: 5,
            labels: {
              enabled: this.ChartProperties.axes,
              format: this.ChartProperties.datalabelFormat == "number" ? '{value}' : '{value}%',
              style: {
                color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
                fontFamily: this.spiderService.textfont
              },
              zIndex: 10
            },
            gridLineStyle: {
              dashStyle: 'dot',  // 'solid', 'dot', 'dash', etc.
              lineWidth: 1,  // The width of grid lines
              lineColor: this.ChartProperties.gridlinecolor,  // Color for grid lines
            },
          },
          pane: {
            size: '80%'
          },
          tooltip: {
            enabled: true,
            borderWidth: 0,
            useHTML: true,
            shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
            shadow: false,
            backgroundColor: 'rgba(0,0,0,0)',
          
            formatter:function (this: any){
              if (this.series.name === 'Marker1') return false;
              let isDefaultTooltip = "style1";//properties.toolTipStyle;
              let text = properties.showDataLabel == true ? this.series.userOptions.roundedValue[this.point.x] : this.y;
              let text1:any;
              if(text!=null){
                  text1= parseFloat(Number(text).toFixed(properties.decimalRoundOff));
              }
              else{
                text1=text;
              }
              const dotColor = this.series.color; // Get the series color
              const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
              const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
              if (isDefaultTooltip == "style1") {
                const commonContent =
                  `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px;font-size: 0.7em; margin: 0; background-color: ${backgroundcolor2}; width:110%">` +
                  `<span style="display: none; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
                  ` ${this.series.name}<br>` +
                  `${this.point.category} : ` +
                  ` ${text1}`;
                return commonContent + '</div>';
              }
              else {
                const content =
                  `<div style="background-color:${backgroundcolor}; padding: 10%; align-items: center; border: 1px solid ${dotColor}; width:120%">` +
                  `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5%;"></div>` +
                  ` ${this.series.name}` +
                  `<div style="display: block; margin-top: 1%;"><strong>Value:</strong> ${text}</div>`;
                return content + '</div>';
              }
            }
        },
          plotOptions: {
            series:{
              animation: false,
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                enabled: false
              },
              select: {
                enabled: false
              }
            },

            },
            line: {
              dashStyle: this.ChartProperties.Linestyle,
              shadow: this.ChartProperties.shadow ? {
                color: this.ChartProperties.darkTheme? 'rgba(255,255,255,0.5)':'rgba(0, 0, 0, 0.5)',
                offsetX: 1,
                offsetY: 1,
                opacity: 0.5,
                width: 5,
              } : false,
              marker: {
                symbol: properties.markerStyle,
              },
              dataLabels:
              {
                allowOverlap: this.ChartProperties.dataLabelOverlap,
                enabled: this.ChartProperties.showDataLabel,
                align: this.ChartProperties.dataLabelPosition,
                rotation: this.ChartProperties.datalabelOrientation,
                color: this.ChartProperties.dataLabelColor == "default" ? (this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor) : this.ChartProperties.dataLabelColor,
                style: {
                  backgroundColor: 'transparent',
                  shadow: false,
                  borderWidth: 0,
                  textOutline: 'none',
                  borderRadius: 0,
                  padding: '2%',
                  fontFamily: this.spiderService.textfont,
                  fontSize: this.ChartProperties.dataLabelSize,
                  fontWeight: "normal"
                },
                formatter: function (this: any) {
                  let sigcolor;
                  const upwardTriangle = '&#9650';
                  const downwardTriangle = '\u25BC';
                  const upColor = 'green';
                  const downColor = 'red';
                  let text; let finalText;
                  let changeText;
                  let sig;
                  let sColor;
    
                  properties.dataLabelFormat = this.isPercentage;
                  let textcolor = properties.dataLabelColor;
                  if (this.series.userOptions.roundedValue[this.point.x] == null || this.series.userOptions.roundedValue[this.point.x] === "") {
                    finalText = "NA";
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
                  if (properties.datalabelStyle == "sigchan") {
                    text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                    changeText = this.series.userOptions.changeValue[this.point.x];
                    sig = this.series.userOptions.significanceValue[this.point.x];
                    sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                    let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                    let changeColor = properties.darkTheme ? 'white' : 'black';
    
                    if (parseFloat(changeText) > 0) {
                      changeText = "+" + changeText;
                    }
                    
                    finalText = (
                      '<span>' + text +
                      (changeText ? '&nbsp<span style="color:' + ';">' +
                        '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                        '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                      '</span>'
                    );
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
    
    
                  if (properties.datalabelStyle == "datalabel") {
                    text = this.y != null? this.y + (properties.datalabelFormat ? '%' : ''):'NA';
                    finalText = (
                      '<span >' + text + '</span>'
                    );
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }

                  if (properties.datalabelStyle === 'sigChange') {
                    let textCheck = configService.CheckLSorIScondition(configService.userRole, String(this.y), Number(this.series.userOptions.sampleSizeValues[this.point.x]));
                    let changeVal = this.series.userOptions.isPercentage[this.point.x] ? (Number(this.series.userOptions.changeValue[this.point.x]) * 100) : (Number(this.series.userOptions.changeValue[this.point.x]));
                    if (this.series.userOptions.changeValue[this.point.x] == null || this.series.userOptions.changeValue[this.point.x] == 'NA') {
                      let text = textCheck + (properties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`;
                      this.series.userOptions.tooltip[this.point.x] = text;
                      return (
                        '<span style="color:' + textcolor + ';">' + text + '</span>'
                      );
                    }
                    else {
                      let sigClass = this.series.userOptions.Significance_Value[this.point.x] < this.series.userOptions.Sig_LowerLimt[this.point.x] ? 'red' : (this.series.userOptions.Significance_Value[this.point.x] > this.series.userOptions.Sig_UpperLimt[this.point.x] ? 'green' : 'black');
                      //let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + (textCheck !='I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) : 'NA'})</span>` : 'NA') : '');
                      let text = textCheck + ((properties.dataLabelFormat && textCheck != 'I/S') ? '%' : '') + ' ' + (textCheck != 'I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${(this.series.userOptions.changeValue[this.point.x] != null ? parseFloat(Number(changeVal).toFixed(1)) + (properties.dataLabelFormat ? '%' : '') : 'NA')})</span>`) : '');
                      this.series.userOptions.tooltip[this.point.x] = text;
                      return (
                        '<span style="color:' + textcolor + ';">' + text + '</span>'
                      );

                    }

                  }

                  if (properties.datalabelStyle === "index") {
                    text = this.y != null? this.y + (properties.datalabelFormat ? '%' : ''):'NA';
                    let text2 = this.series.userOptions.ActualIndexValue[this.point.x] == null ? 'NA' : this.y == -1 ? -1 : this.y != null ? this.series.userOptions.ValueForIndex[this.point.x].toFixed(1) : 'NA';

                    if (text2 == "-1" || text2 == -1) {
                      text2 = "NA";
                    }
                    let color = configService.CheckIndexColoring(String(text2));
                      this.tooltip = text + "(" + text2 + ")";
                      finalText = (
                        '<span style="font-size:0.5rem;color:' + textcolor + ';">' + text + " " + '(' +
                        '<span style="color:' + color + ';font-size:0.45rem;">' + text2 + '</span>' + ')</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                  }
    
                  if (properties.datalabelStyle == "change") {
                    text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                    changeText = this.series.userOptions.changeValue[this.point.x];
                    let changeColor = properties.darkTheme ? 'white' : 'black';
    
                    if (parseFloat(changeText) > 0) {
                      changeText = "+" + changeText;
                    }
                    
                    finalText = (
                      '<span>' + text +
                      (changeText ? '&nbsp<span style="color:' + ';">' +
                        '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                        '</span>' : '') +
                      '</span>'
                    );
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
    
                  if (properties.datalabelStyle == "significance") {
                    text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA';
                    sig = this.series.userOptions.significanceValue[this.point.x];
                    let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                    sigcolor = sig > 0 ? upColor : (sig < 0 ? downColor : '');
    
                    finalText = (
                      '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>'
                    );
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
    
                  if (properties.datalabelStyle == "significance2") {
                    text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA';
                    changeText = this.series.userOptions.changeValue[this.point.x];
                    sig = this.series.userOptions.significanceValue[this.point.x];
                    let sig1 = this.series.userOptions.significanceValue2[this.point.x];
                    sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                    let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                    let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? 'white' : 'black');
    
                    if (parseFloat(changeText) > 0) {
                      changeText = "+" + changeText;
                    }
    
                    finalText = (
                      '<span>' + text +
                      (this.y != 0 && changeText ? '&nbsp<span style="color:' + ';"> ' +
                        '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                        '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                      '</span>'
                    );
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
    
                  if (properties.datalabelStyle == 'lowSample') {
                    text = parseFloat(this.series.userOptions.sampleSizeValues[this.point.x]) > sampleSizeConstant ? this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA' : 'LS';
                    finalText = (
                      '<span>' +
                      text +
                      '</span> ' +
                      '<span style="opacity: 0.5"></span>'
                    );
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
    
                  finalText = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                  this.series.userOptions.tooltip[this.point.x]=finalText;
                  return finalText;
                }
              }
            }
          },
          series: this.seriesData,
        } as any;
        this.chart = Highcharts.chart(container2, options);
      }
    }
    else{
          localStorage.setItem("properties", JSON.stringify(properties));
          this.accessSeriesValues(this.ChartProperties.datalabelStyle == 'lowSample',this.ChartData);
          let maxDataValue = 0;
          const numberOfTicks = 15;
          const sampleSizeConstant = this.spiderService.sampleSizeConstant;

          if (this.ChartProperties.gradient) {
            this.seriesData.forEach((series, index) => {
              series.color = this.spiderService.customColors1[index % this.spiderService.customColors1.length]; // Assign colors from customColors1
            });
          }
          else {
            this.seriesData.forEach((series, index) => {
              series.color = this.spiderService.customColors[index % this.spiderService.customColors.length]; // Assign colors from customColors2
            });
          }

          const maxArray: number[] = new Array<number>(this.seriesData[0].data.length).fill(0);

          // Find the maximum value at each index across all series
          this.seriesData.forEach(series => {
            series.data.forEach((value: any, index: any) => {
              maxArray[index] = Math.max(maxArray[index], value);
            });
          });

          // Now maxArray contains the maximum value at each index
          maxDataValue = Math.max(...maxArray);
          maxDataValue = maxDataValue + Math.ceil(maxDataValue * 0.1);
          const tickInterval = Math.ceil(maxDataValue / numberOfTicks);

          const options: Highcharts.Options = {
            chart: {
              polar: true,
              type: 'line',
              backgroundColor: this.ChartProperties.darkTheme ? this.spiderService.darkThemebg : this.spiderService.lightThemebg,
              style: {
                fontFamily: this.spiderService.textfont,
                color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
              }
            },
            title: {
              text: "",
              align: this.ChartProperties.chartTitlePosition,
              style: {
                color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
                marginleft: '4%',
                fontSize: '2em',
                fontFamily: this.spiderService.textfont
              }
            },
            exporting: {
              enabled: false
            },
            credits: {
              enabled: false,
            },
            legend: this.spiderService.customizeLegendRadar(this.ChartProperties.showLegend, this.ChartProperties.legendPosition, this.ChartProperties),
            xAxis: {
              categories: this.chartCategories,
              tickmarkPlacement: 'on',
              lineWidth: 0,
              labels: {
                rotation: this.spiderService.xAxisLabelOrientation(this.ChartProperties.axisLabelOrientation, this.ChartProperties),
                style: {
                  color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
                  fontFamily: this.spiderService.textfont
                }
              }
            },
            yAxis: {
              visible:  true,
              gridLineWidth: 1,
              gridLineInterpolation: 'polygon',
              lineWidth: 0,
              gridLineColor: this.ChartProperties.gridlinecolor,
              gridLineDashStyle: this.ChartProperties.gridlinestyle,
              min: 0,
              max: maxDataValue, // Adjust this value based on your data
              tickInterval: tickInterval,
              labels: {
                enabled: false,
                format: this.ChartProperties.datalabelFormat == "number" ? '{value}' : '{value}%',
                style: {
                  color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
                  fontFamily: this.spiderService.textfont
                },
              },
              gridLineStyle: {
                dashStyle: 'dot',  // 'solid', 'dot', 'dash', etc.
                lineWidth: 1,  // The width of grid lines
                lineColor: this.ChartProperties.gridlinecolor,  // Color for grid lines
              }
            },
            pane: {
              size: '80%'
            },
            tooltip: {
              enabled: true,
              borderWidth: 0,
              useHTML: true,
              shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
              shadow: false,
              backgroundColor: 'rgba(0,0,0,0)',
            
              formatter:function (this: any){
                if (this.series.name === 'Marker1') return false;
                let isDefaultTooltip = "style1";//properties.toolTipStyle;
                let text = properties.showDataLabel == true ? this.series.userOptions.roundedValue[this.point.x] : this.y;
                let text1:any;
                if(text!=null){
                    text1= parseFloat(Number(text).toFixed(properties.decimalRoundOff));
                }
                else{
                  text1=text;
                }
                const dotColor = this.series.color; // Get the series color
                const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
                const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
                if (isDefaultTooltip == "style1") {
                  // const commonContent =
                  //   `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2}; width:110%">` +
                  //   `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 1rem;">Tooltip Title</span>` +
                  //   `<span><strong>Series Name:</strong></span> ${this.series.name}<br>` +
                  //   `<span><strong>Category Name:</strong></span> ${this.point.category}<br>` +
                  //   `<span><strong>Value:</strong></span> ${text1}`;
                  // return commonContent + '</div>';
                  const commonContent =
                  `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px;font-size: 0.8em; margin: 0; background-color: ${backgroundcolor2}; width:110%">` +
                  `<span style="display: none; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
                  ` ${this.series.name}<br>` +
                  `${this.point.category} : ` +
                  ` ${text1}`;
                   return commonContent + '</div>';
                }
                else {
                  const content =
                    `<div style="background-color:${backgroundcolor}; padding: 10%; align-items: center; border: 1px solid ${dotColor}; width:120%">` +
                    `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5%;"></div>` +
                    ` ${this.series.name}` +
                    `<div style="display: block; margin-top: 1%;"><strong>Value:</strong> ${text}</div>`;
                  return content + '</div>';
                }
              }
          },
            plotOptions: {
              series:{
                animation: false,
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                enabled: false
              },
              select: {
                enabled: false
              }
            },
              },
              line: {
                dashStyle: this.ChartProperties.Linestyle,
                shadow: this.ChartProperties.shadow ? {
                  color: this.ChartProperties.darkTheme? 'rgba(255,255,255,0.5)':'rgba(0, 0, 0, 0.5)',
                  offsetX: 1,
                  offsetY: 1,
                  opacity: 0.5,
                  width: 5,
                } : false,
                marker: {
                  symbol: properties.markerStyle,
                },
                dataLabels:
                {
                  allowOverlap: this.ChartProperties.allowOverlap,
                  enabled: this.ChartProperties.showDataLabel,
                  align: this.ChartProperties.dataLabelPosition,
                  rotation: this.ChartProperties.datalabelOrientation,
                  color: this.ChartProperties.dataLabelColor == "default" ? (this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor) : this.ChartProperties.dataLabelColor,
                  style: {
                    backgroundColor: 'transparent',
                    shadow: false,
                    borderWidth: 0,
                    textOutline: 'none',
                    borderRadius: 0,
                    padding: '2%',
                    fontFamily: this.spiderService.textfont,
                    fontSize: this.ChartProperties.dataLabelSize,
                    fontWeight: "normal"
                  },
                  formatter: function (this: any) {
                    let sigcolor;
                    const upwardTriangle = '&#9650';
                    const downwardTriangle = '\u25BC';
                    const upColor = 'green';
                    const downColor = 'red';
                    let text; let finalText;
                    let changeText;
                    let sig;
                    let sColor;

                    if (this.series.userOptions.roundedValue[this.point.x] == null || this.series.userOptions.roundedValue[this.point.x] === "") {
                      finalText = "NA";
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
                    if (properties.datalabelStyle == "sigchan") {
                      text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                      changeText = this.series.userOptions.changeValue[this.point.x];
                      sig = this.series.userOptions.significanceValue[this.point.x];
                      sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                      let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                      let changeColor = properties.darkTheme ? 'white' : 'black';

                      if (parseFloat(changeText) > 0) {
                        changeText = "+" + changeText;
                      }
                      
                      finalText = (
                        '<span>' + text +
                        (changeText ? '&nbsp<span style="color:' + ';">' +
                          '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                          '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                        '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }


                    if (properties.datalabelStyle == "datalabel") {
                      text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                      finalText = (
                        '<span >' + text + '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }

                    if (properties.datalabelStyle == "change") {
                      text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                      changeText = this.series.userOptions.changeValue[this.point.x];
                      let changeColor = properties.darkTheme ? 'white' : 'black';

                      if (parseFloat(changeText) > 0) {
                        changeText = "+" + changeText;
                      }
                      
                      finalText = (
                        '<span>' + text +
                        (changeText ? '&nbsp<span style="color:' + ';">' +
                          '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                          '</span>' : '') +
                        '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }

                    if (properties.datalabelStyle == "significance") {
                      text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA';
                      sig = this.series.userOptions.significanceValue[this.point.x];
                      let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                      sigcolor = sig > 0 ? upColor : (sig < 0 ? downColor : '');

                      finalText = (
                        '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }

                    if (properties.datalabelStyle == "significance2") {
                      text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA';
                      changeText = this.series.userOptions.changeValue[this.point.x];
                      sig = this.series.userOptions.significanceValue[this.point.x];
                      let sig1 = this.series.userOptions.significanceValue2[this.point.x];
                      sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                      let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                      let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? 'white' : 'black');

                      if (parseFloat(changeText) > 0) {
                        changeText = "+" + changeText;
                      }

                      finalText = (
                        '<span>' + text +
                        (this.y != 0 && changeText ? '&nbsp<span style="color:' + ';"> ' +
                          '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                          '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                        '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }

                    if (properties.datalabelStyle == 'lowSample') {
                      text = parseFloat(this.series.userOptions.sampleSizeValues[this.point.x]) > sampleSizeConstant ? this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA' : 'LS';
                      finalText = (
                        '<span>' +
                        text +
                        '</span> ' +
                        '<span style="opacity: 0.5"></span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }

                    finalText = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
                }
              }
            },
            series: this.seriesData,
          } as any;
          this.chart = Highcharts.chart(container2, options);
    }
  }

  commonfunc(event: any, customization: string) {
    this.event = event;
    this.spiderService.commonFunc2(customization, event, this.ChartProperties)
    this.renderChart2('chart-container'+ this.id, this.data['data'], this.ChartProperties);
  }

  customization(): Observable<any[]> {
    // return this.piechartservice.PieChart1to10customizationList();
    return _.cloneDeep(this._customSnapshotService.getChartCustomization("Spider/ Radar", this._customSnapshotService.selectedSnapshotType?.name));
  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.spiderService.applycustomization(event, item, this.ChartProperties)
    this.renderChart2('chart-container'+ this.id, this.data['data'], this.ChartProperties);
  }


  userselectedproperties() {
    this.data["properties"][0] = this.ChartProperties;
    this.data["data"] = this.ChartData;
    return JSON.stringify(this.data).toString();
  }
}
